import { render, staticRenderFns } from "./my_table.vue?vue&type=template&id=b01a7fb4&scoped=true&"
import script from "./my_table.vue?vue&type=script&lang=js&"
export * from "./my_table.vue?vue&type=script&lang=js&"
import style0 from "./my_table.vue?vue&type=style&index=0&id=b01a7fb4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b01a7fb4",
  null
  
)

export default component.exports